import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { hasFeature } from '@app/core/functions/feature-flag.functions';

@Directive({ selector: '[hasFeature]' })
export class HasFeatureDirective {
  constructor(private readonly templateRef: TemplateRef<any>, private readonly viewContainer: ViewContainerRef) {}

  /**
   * Validate if feature flag is enabled
   * @returns {string} The feature.
   */
  @Input()
  set hasFeature(feature: string) {
    const condition = hasFeature(feature);    

    if (condition) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
